import React, { FC, ReactNode } from 'react';
import { UseFormRegisterReturn } from 'react-hook-form';
import styles from './InputField.module.scss';

export interface InputFieldProps {
  placeholder: string;
  name?: string;
  error?: boolean;
  className?: string;
  image?: ReactNode;
  tabIndex?: number;
  register?: UseFormRegisterReturn<any>;
  ref?: any;
  tableInput?: boolean;
  inputWrapperClassName?: string;
  type?: 'input' | 'password' | 'number';
  autoComplete?: boolean;
  inputMode?: React.HTMLAttributes<HTMLInputElement>['inputMode'];
  pattern?: string;
  disabled?: boolean;
}

/**
 * @param props - The props for the component.
 * @param name - name for the input.
 * @param placeholder - placeholder for the input.
 * @param tabIndex - tab index for the input.
 * @param className - custom class name for the input.
 * @param type - input type 'input' | 'password'.
 * @param image - An image or icon in input.
 * @param inputWrapperClassName - custom class name for the input wrapper.
 * @param ref - ref for the input.
 * @param tableInput - Indicate is input using in tab
 * @param autoComplete - Indicates if input need to auto complete.
 * @param error - Indicates error in input.
 * @description - Form input shared component for forms
 * @returns A React component that displays an input.
 */

const InputField: FC<InputFieldProps> = React.forwardRef((props, ref) => {
  const {
    className,
    image,
    tableInput,
    error,
    register,
    inputWrapperClassName,
    autoComplete,
    inputMode,
    pattern,
    disabled,
    ...rest
  } = props;
  return (
    <div
      className={[
        styles.inputWrapper,
        inputWrapperClassName,
        !tableInput ? styles.default : styles.tableWrapper,
        error && styles.error,
        disabled && styles.disabled,
      ].join(' ')}
    >
      {image}
      <input
        type="text"
        ref={ref}
        className={[className].join(' ')}
        {...rest}
        autoComplete={autoComplete ? 'on' : 'off'}
        inputMode={inputMode}
        pattern={pattern}
        disabled={disabled}
      />
    </div>
  );
});

export default InputField;
